import React, { useEffect, useState } from 'react'
import Button from 'components/controls/button'
import { localizedTranslate } from 'assets/localization'
import { connect } from 'react-redux'
import { axiosInstance } from 'network/apis'
import { Spinner } from '@blueprintjs/core'


import 'less/unsubscribe.less'


function mapStateToProps(state) {
  return {
    t: localizedTranslate('en', state.translations.en_us)
  }
}

const UnSubscribe = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [spinnerLoading, setSpinnerLoading] = useState(true)
  const [email, setEmail] = useState("")
  const userId = props.match.params.userId

  async function fetchUserEmail() {

    try {
      const result = await axiosInstance.get(`user/get-email/${userId}`, { handlerEnabled: false })
      setEmail(result.data.email)
      setSpinnerLoading(false)
    } catch (e) {
      setEmail(props.t('unsubscribe.error.getting.email'))
      console.log("an error occured ", e)
      setSpinnerLoading(false)
      props.showSnackbarMessageError(props.t('unsubscribe.error.getting.email'))
      props.hideSnackbarMessage()
    }
  }

  useEffect(() => {
    setSpinnerLoading(true)
    console.log("userId : ", userId)
    fetchUserEmail()
  }, [])

  const handleValidation = async () => {
    try {
      setIsLoading(true)
      let payload = {
        "allowContactByEmail": "0"
      }
      await axiosInstance.post(`unsubscribe/unsubscribe-user/${userId}`, payload, { handlerEnabled: true })
      setIsLoading(false)
      props.history.push('/unsubscribe/success')
    } catch (e) {
      setIsLoading(false)
      console.log("an error occured ", e)
      props.showSnackbarMessageError(props.t('unsubscribe.action.error'))
      props.hideSnackbarMessage()
    }
  }

  return (
    <div >
      <div className="separator"></div>
      <div className='main-apollo-logo' />
      <div className="main-unsubscribe">
        <div className="main-unsubscribe-right">
          <div className="main-unsubscribe-right-container">
            <div className="password">
              <div class="unsusbscribe-text">
                {props.t('unsubscribe.welcome.message')}
              </div>
              <br />
              {spinnerLoading ? <Spinner intent="primary" /> : <div class="unsusbscribe-email">
                {email}
              </div>}
            </div>
            <div className={isLoading ? 'unsubscribe-button-loading' : 'unsubscribe-button'}>
              <Button
                className="unsubscribe"
                onClick={handleValidation}
                disabled={spinnerLoading}
                isLoading={isLoading}
              > Yes
                <i className="spin-me im-arrow-right2" />
              </Button>
            </div>
          </div>
        </div>
        <div className="main-unsubscribe-left">
          <div className="unsubscribe-logo-container" >
            <div className="i-wrap">
              <i className="im-paper-plane"></i>
            </div>
            <span>Unsubscribe</span>
          </div>
        </div>
      </div>
      <div className="footer" >
        <div className="footer-info"></div>
        <div className="footer-line"></div>
        <span >{props.t("appolo.rights")}</span>
      </div>
    </div>
  )
}

const mapDispatch = {
  showSnackbarMessageError: message => ({
    type: 'SHOW_MESSAGE',
    payload: {
      message: message,
      className: 'copy-screeners-snackbar',
    },
  }),
  hideSnackbarMessage: () => ({ type: 'HIDE_MESSAGE' })
}

export default connect(mapStateToProps, mapDispatch, null)(UnSubscribe)
